import type React from 'react'
import styled from 'styled-components'

interface FormControlProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  error?: boolean
}

export const FormControl = styled.div.attrs<FormControlProps>(({ error = false }) => ({
  'data-form-control-error': error,
}))<FormControlProps>`
  border: 0;
  display: inline-flex;
  flex-direction: column;
  margin: 0;
  min-width: 0;
  padding: 0;
  position: relative;
  text-align: left;
  vertical-align: top;
  width: 100%;
`
